'use client'

import { cn } from '@ui/lib/utils'

import { useFormContext } from './formContext'

// A validator's `{ form }` lands in errorMap.onSubmit as a bare string, or as
// `{ form }` when schema validators are also registered. Per-field schema
// issues land there too (keyed by field) and are not form-level. A thrown
// validator lands as the Error itself and renders nothing — transport
// failures toast from the Apollo link instead.
const formMessage = (error: unknown): string | null => {
  if (typeof error === 'string') return error
  if (error && typeof error === 'object' && 'form' in error) {
    const { form } = error as { form: unknown }
    return typeof form === 'string' ? form : null
  }
  return null
}

// Always rendered at one line of height so a form-level error never shifts
// the layout when it appears.
export function FormError({ className }: { className?: string }) {
  const form = useFormContext()
  return (
    <form.Subscribe selector={(state) => formMessage(state.errorMap.onSubmit)}>
      {(message) => (
        <p
          role="alert"
          aria-live="polite"
          className={cn(
            'text-destructive min-h-5 text-center text-sm',
            className,
          )}
        >
          {message}
        </p>
      )}
    </form.Subscribe>
  )
}
